import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import CityCombobox from "../components/CityCombobox";

export default function Register() {
    const navigate = useNavigate();
    const { checkAuth } = useAuth();
    const [form, setForm] = React.useState({ name: "", email: "", phone: "", password: "", confirm_password: "", county: "", city: "", postal_code: "", street: "", number: "", bloc_ap: "", referral_code: "" });
    const [counties, setCounties] = React.useState([]);
    const [cities, setCities] = React.useState([]);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        api.get("/locations/counties").then(r => setCounties(r.data || []));
        const savedRef = localStorage.getItem("ref_code");
        if (savedRef) setForm(f => ({ ...f, referral_code: savedRef }));
    }, []);
    React.useEffect(() => {
        if (form.county) api.get("/locations/cities", { params: { county: form.county } }).then(r => setCities(r.data || []));
        else setCities([]);
    }, [form.county]);

    const submit = async (e) => {
        e.preventDefault();
        if (form.password !== form.confirm_password) {
            toast.error("Parolele nu coincid"); return;
        }
        setLoading(true);
        try {
            const { confirm_password, street, number, bloc_ap, ...rest } = form;
            const address = [street, number, bloc_ap].filter(Boolean).join(", ");
            const payload = { ...rest, address };
            const res = await api.post("/auth/register-full", payload);
            localStorage.setItem("st_token", res.data.token);
            localStorage.removeItem("ref_code");
            await checkAuth();
            toast.success("Cont creat cu succes! Bun venit.");
            navigate("/cont");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Eroare la înregistrare");
        } finally { setLoading(false); }
    };

    return (
        <div className="container-x py-16 max-w-lg mx-auto" data-testid="register-page">
            <h1 className="font-heading text-4xl mb-2">Creează cont</h1>
            <p className="text-sm text-muted-foreground mb-6">Adresa completă ne ajută să-ți livrăm mai rapid.</p>
            <form onSubmit={submit} className="space-y-3" data-testid="register-form">
                <input required name="name" placeholder="Nume complet" value={form.name} onChange={(e) => setForm(f => ({ ...f, name: e.target.value }))} className="input-soft" data-testid="register-name-input" />
                <input required name="email" type="email" placeholder="Email" value={form.email} onChange={(e) => setForm(f => ({ ...f, email: e.target.value }))} className="input-soft" data-testid="register-email-input" />
                <input required name="phone" placeholder="Telefon" value={form.phone} onChange={(e) => setForm(f => ({ ...f, phone: e.target.value }))} className="input-soft" data-testid="register-phone-input" />
                <input required name="password" type="password" placeholder="Parolă (min 8)" minLength={8} value={form.password} onChange={(e) => setForm(f => ({ ...f, password: e.target.value }))} className="input-soft" data-testid="register-password-input" />
                <input required name="confirm_password" type="password" placeholder="Confirmă parola" minLength={8} value={form.confirm_password} onChange={(e) => setForm(f => ({ ...f, confirm_password: e.target.value }))} className="input-soft" data-testid="register-confirm-password-input" />
                <div className="grid grid-cols-2 gap-3">
                    <select name="county" value={form.county} onChange={(e) => setForm(f => ({ ...f, county: e.target.value, city: "", postal_code: "" }))} className="input-soft" data-testid="register-county-input">
                        <option value="">Județ</option>
                        {counties.map(c => <option key={c}>{c}</option>)}
                    </select>
                    <CityCombobox
                        cities={cities}
                        value={form.city}
                        onChange={(v) => setForm(f => ({ ...f, city: v }))}
                        onPostalCode={(pc) => setForm(f => ({ ...f, postal_code: f.postal_code || pc }))}
                        placeholder="Localitate (oraș / sat / comună)"
                        required
                        data-testid="register-city-input"
                    />
                </div>
                <input name="postal_code" placeholder="Cod poștal" value={form.postal_code} onChange={(e) => setForm(f => ({ ...f, postal_code: e.target.value }))} className="input-soft" data-testid="register-postal-code-input" />
                <div className="grid grid-cols-3 gap-3">
                    <input name="street" placeholder="Strada" value={form.street} onChange={(e) => setForm(f => ({ ...f, street: e.target.value }))} className="input-soft col-span-2" data-testid="register-street-input" />
                    <input name="number" placeholder="Număr" value={form.number} onChange={(e) => setForm(f => ({ ...f, number: e.target.value }))} className="input-soft" data-testid="register-number-input" />
                </div>
                <input name="bloc_ap" placeholder="Bloc / Scară / Apartament (opțional)" value={form.bloc_ap} onChange={(e) => setForm(f => ({ ...f, bloc_ap: e.target.value }))} className="input-soft" data-testid="register-blocap-input" />
                <input name="referral_code" placeholder="Cod referral (opțional)" value={form.referral_code} onChange={(e) => setForm(f => ({ ...f, referral_code: e.target.value.toUpperCase() }))} className="input-soft" data-testid="register-referral-input" />
                <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="register-submit-button">{loading ? "..." : "Creează cont"}</button>
            </form>
            <p className="mt-6 text-center text-sm text-muted-foreground">Ai deja cont? <Link to="/login" className="text-primary font-medium">Autentifică-te</Link></p>
        </div>
    );
}
